const FINNISH_MONTHS = [
  'tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu',
  'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu',
]

const FINNISH_MONTHS_SHORT = [
  'tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä',
  'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu',
]

export function formatDateFi(dateStr: string): string {
  const d = new Date(dateStr)
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`
}

export function formatDateTimeFi(dateStr: string): string {
  const d = new Date(dateStr)
  const hours = d.getHours().toString().padStart(2, '0')
  const minutes = d.getMinutes().toString().padStart(2, '0')
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${hours}:${minutes}`
}

export function formatRelativeTimeFi(dateStr: string): string {
  const now = new Date()
  const d = new Date(dateStr)
  const diffMs = now.getTime() - d.getTime()
  const diffMin = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMin < 1) return 'juuri nyt'
  if (diffMin < 60) return `${diffMin} min sitten`
  if (diffHours < 24) return `${diffHours} t sitten`
  if (diffDays < 7) return `${diffDays} pv sitten`
  return formatDateFi(dateStr)
}

export function getMonthNameFi(month: number): string {
  return FINNISH_MONTHS[month]
}

export function getMonthNameShortFi(month: number): string {
  return FINNISH_MONTHS_SHORT[month]
}

export function isOverdue(dateStr: string): boolean {
  return new Date(dateStr) < new Date()
}

/**
 * Returns due-date countdown info: label text and color class.
 * - Gray: more than 5 days remaining
 * - Yellow: 1–5 days remaining
 * - "Tänään": due today
 * - Red: overdue
 */
export function getDueDateInfo(dateStr: string): {
  text: string
  colorClass: string
} | null {
  const due = new Date(dateStr)
  if (isNaN(due.getTime())) return null

  const now = new Date()
  // Strip time components to compare calendar days only
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const dueStart = new Date(due.getFullYear(), due.getMonth(), due.getDate())

  const diffMs = dueStart.getTime() - todayStart.getTime()
  const diffDays = Math.round(diffMs / 86400000)

  if (diffDays < 0) {
    const overdue = Math.abs(diffDays)
    return {
      text: `${overdue} ${overdue === 1 ? 'päivä' : 'päivää'} myöhässä`,
      colorClass: 'text-red-600',
    }
  }

  if (diffDays === 0) {
    return { text: 'Tänään', colorClass: 'text-yellow-600' }
  }

  if (diffDays <= 5) {
    return {
      text: `${diffDays} ${diffDays === 1 ? 'päivä' : 'päivää'} jäljellä`,
      colorClass: 'text-yellow-600',
    }
  }

  return {
    text: `${diffDays} päivää jäljellä`,
    colorClass: 'text-muted-foreground',
  }
}

export function toSentenceCase(name?: string | null): string {
  if (!name) return "";
  const trimmed = name.trim();
  if (!trimmed) return "";
  if (/[a-zäö]/.test(trimmed)) return trimmed;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}
